import Command from '@ckeditor/ckeditor5-core/src/command'
import { Model } from '@ckeditor/ckeditor5-engine'
import findAttributeRange from '@ckeditor/ckeditor5-typing/src/utils/findattributerange'

export class UnanchorCommand extends Command {
  execute() {
    const model = this.editor.model

    model.change((writer) => {
      const rangesToUnanchor = this._getRangesToUnanchor(model)

      // Remove `anchorId` attribute from specified ranges.
      for (const range of rangesToUnanchor) {
        writer.removeAttribute('anchorId', range)
      }
    })
  }

  private _getRangesToUnanchor(model: Model) {
    const selection = model.document.selection
    const position = selection.getFirstPosition()
    const selectedElement = selection.getSelectedElement()
    const anchorId = selection.getAttribute('anchorId') ?? selectedElement?.getAttribute('anchorId')

    if (selection.isCollapsed && position && typeof anchorId === 'string') {
      return [findAttributeRange(position, 'anchorId', anchorId, model)]
    } else if (selectedElement) {
      return [selectedElement]
    } else {
      return model.schema.getValidRanges(Array.from(selection.getRanges()), 'anchorId')
    }
  }
}
